import {
  selectActiveSortingType,
  setActiveSortingType,
  setFilteredProducts,
} from "features/category/categorySlice";
import {
  setActiveFilters,
  setActiveFiltersCount,
} from "features/Filters/filtersSlice";
import { setPage } from "features/pagination/paginationSlice";
import useComponentVisible from "hooks/useComponentVisible";
import { SortingType } from "pages/category/types";
import { dropdownOptions } from "pages/category/utils";
import React from "react";
import { MdArrowDropDown } from "react-icons/md";
import { ImSortAlphaAsc } from "react-icons/im";
import { batch, useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";
import { DefaultText } from "theme/GlobalElements";
import { colors } from "theme/Theme";
import { device, Mobile, TabletUp } from "theme/Breakpoints";

interface DropdownCategoryProps {}

const DropdownCategory: React.FC<DropdownCategoryProps> = () => {
  const dispatch = useDispatch();
  const { ref, isComponentVisible, toggleIsVisible } =
    useComponentVisible(false);

  const activeCategorySortingType = useSelector(selectActiveSortingType);

  const onItemSelected = (sortingType: SortingType) => {
    if (sortingType !== activeCategorySortingType) {
      batch(() => {
        dispatch(setPage(1));
        dispatch(setActiveFiltersCount(0));
        dispatch(setActiveFilters([]));
        dispatch(setFilteredProducts([]));
        dispatch(setActiveSortingType(sortingType));
      });
    }
  };

  return (
    <SortDropdown>
      <TabletUp>
        <DropdownTitle
          ref={ref}
          isOpen={isComponentVisible}
          onClick={toggleIsVisible}
        >
          <DefaultText>
            {
              dropdownOptions.find(
                (option) => option.sortingType === activeCategorySortingType
              )?.title
            }
          </DefaultText>
          <MdArrowDropDown
            className="dropdown-arrow-expanded"
            color="black"
            size="1.5em"
          />
        </DropdownTitle>
      </TabletUp>
      <Mobile>
        <div ref={ref} onClick={toggleIsVisible}>
          <ImSortAlphaAsc size="1.5em" />
        </div>
      </Mobile>
      {isComponentVisible && (
        <DropdownItemsContainer>
          {dropdownOptions.map((item) => {
            return (
              <DropdownItem
                key={item.title}
                onClick={() => onItemSelected(item.sortingType)}
              >
                <DefaultText
                  style={{
                    whiteSpace: "normal",
                    fontWeight:
                      item.sortingType === activeCategorySortingType
                        ? 700
                        : 500,
                  }}
                >
                  {item.title}
                </DefaultText>
              </DropdownItem>
            );
          })}
        </DropdownItemsContainer>
      )}
    </SortDropdown>
  );
};

const SortDropdown = styled.div`
  margin-top: 5px;
  display: flex;
  flex-flow: column nowrap;
  position: relative;
  @media only screen and (${device.tablet}) {
    min-width: 200px;
  }
`;

const DropdownTitle = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 5px 10px;
  border: 1px solid ${colors.light_blue};
  justify-content: space-between;

  .dropdown-arrow-expanded {
    transition: 0.3s all;
    transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  }
`;

const DropdownItem = styled.div`
  background-color: white;
  padding: 5px 10px;
  border: 1px solid ${colors.dark_gray};

  &:hover {
    border: 1px solid ${colors.light_blue};
  }
`;

const DropdownItemsContainer = styled.div`
  position: absolute;
  top: 100%;
  z-index: 11;
  min-width: 200px;
  right: 0;
  @media only screen and (${device.tablet}) {
    width: 100%;
    left: 0;
  }
`;

export default DropdownCategory;
